import React from 'react';

import { Toolbar, Box, Paper } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { makeStyles } from '@material-ui/core/styles';

import Header from './headers/Header';

import {
  MAIN_HEADER_MIN_HEIGHT,
  PROFILE_HEIGHT,
  DESKTOP_NAVIGATION_MENU_HEIGHT,
  MARGIN_HEADER,
} from '../../../constants/Layout';

const useStyles = makeStyles(() => ({
  root: {
    height: PROFILE_HEIGHT,
  },
  box: {
    padding: '44px 16px 26px 16px',
    boxSizing: 'border-box',
  },
  skeletonImg: {
    margin: 'auto',
  },
  text: {
    margin: 'auto',
    marginTop: 32,
    marginBottom: 30,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    margin: 'auto',
    marginBottom: 30,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  rootNavigation: {
    height: DESKTOP_NAVIGATION_MENU_HEIGHT,
  },
  container: {
    padding: '0px 16px',
    marginBottom: `-${MARGIN_HEADER}px`,
  },
}));

const MobileLayoutSkeleton = () => {
  const classes = useStyles();
  return (
    <Box display="flex" flexDirection="column">
      <Header />
      <Toolbar style={{ height: MAIN_HEADER_MIN_HEIGHT }} />
      <Paper className={classes.root}>
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          alignContent="space-between"
          className={classes.box}
        >
          <Skeleton
            className={classes.title}
            variant="rect"
            width={250}
            height={40}
          />
          <Skeleton
            className={classes.skeletonImg}
            variant="rect"
            width={185}
            height={185}
          />
          <Skeleton
            className={classes.text}
            variant="rect"
            width={250}
            height={40}
          />
        </Box>
      </Paper>
      <Paper elevation={0} className={classes.rootNavigation}>
        <Box display="flex" flexDirection="column">
          <Skeleton variant="rect" width={'100%'} height={120} />
        </Box>
      </Paper>
      <Paper elevation={0} className={classes.container}>
        <Skeleton
          variant="rect"
          width={'100%'}
          height={300}
          className={classes.text}
        />
      </Paper>
    </Box>
  );
};

export default MobileLayoutSkeleton;
